import { createCamera } from './components/camera.js';
import { createCube } from './components/cube.js';
import { createMesh2 } from './components/mesh2.js';
import { createLights } from './components/lights.js';
import { createLights2 } from './components/lights2.js';
import { createRectAreaLight } from './components/rectAreaLight.js';
import { createScene } from './components/scene.js';

import { createRenderer } from './systems/renderer.js';
import { Resizer } from './systems/Resizer.js';

let camera;
let scene;
let renderer;

class World {
  constructor(container) {

    camera = createCamera();
    scene = createScene();
    renderer = createRenderer(container);
    console.log(camera, 'camera', scene, 'scene', renderer, 'renderer');
    // container.append(renderer.domElement); // 添加一个canvas 元素， 我的container已经是 canvas了 这里就注释

    const cube = createCube();

    const cube2Ins = createMesh2();
    cube2Ins.position.set( 3, 0, 0 );

    // eslint-disable-next-line
    const light = createLights();
    // eslint-disable-next-line
    const light2 = createLights2();
    // eslint-disable-next-line
    const light3 = createRectAreaLight();

    scene.add(
      cube,
      cube2Ins,
      light,
      light2,
      light3,
    );

    // eslint-disable-next-line
    const resizer = new Resizer(container, camera, renderer);
  }

  // 2. Render the scene
  render() {
    renderer.render(scene, camera);
  }
}

export { World };